export default __webpack_public_path__ + "static/media/arrow-left-carousel.7bb6e3ac.svg";